import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontSizes, fontWeights, borderRadiuses, palette, breakpoints,
}: Theme) => ({
  iconWrapper: {
    '& img': {
      display: 'block',
      height: 60,
      objectFit: 'contain',
      [breakpoints.up('md')]: {
        height: 128,
      },
    },
  },
  actionLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: '1.75rem',
    padding: '0.75rem',
    border: `2px solid ${palette.common.white}`,
    borderRadius: borderRadiuses.xl,
    color: palette.common.white,
    background: `linear-gradient(245.79deg, ${palette.primary.main} 8.65%, ${palette.primary.dark} 90.3%)`,
    fontSize: fontSizes.xs,
    lineHeight: 1,
    textDecoration: 'none',
    fontWeight: fontWeights.medium,
    textTransform: 'uppercase',
    [breakpoints.up('lg')]: {
      marginTop: 40,
      padding: 22,
      fontSize: fontSizes.lg,
    },
    '&.child': {
      background: 'linear-gradient(93.04deg, #08CF54 10.03%, #00A3E0 94.69%)',
    },
  },
  title: {
    width: '100%',
    margin: '1.75rem 0 0.75rem',
    color: '#a51890',
    fontSize: fontSizes.sm,
    lineHeight: 1,
    fontWeight: fontWeights.medium,
    textAlign: 'left',
    [breakpoints.up('lg')]: {
      padding: '0 30px',
      fontSize: fontSizes.xl,
    },
    '&.child': {
      marginTop: 0,
      color: '#685bc7',
      fontSize: '1.125rem',
      letterSpacing: '-0.01em',
    },
  },
  description: {
    flexGrow: 1,
    width: '100%',
    margin: 0,
    color: palette.info.dark,
    fontSize: '0.75rem',
    lineHeight: 1.3,
    textAlign: 'left',
    listStyle: 'circle',
    [breakpoints.up('lg')]: {
      padding: '0 30px',
      fontSize: fontSizes.lg,
    },
    '&.child': {
      fontSize: fontSizes.xs,
    },
  },
  link: {
    color: palette.secondary.main,
    textDecoration: 'none',
  },
  index: {},
  indexIcon: {
    position: 'absolute',
    top: -12,
    left: -12,
    width: 30,
    height: 30,
    objectFit: 'contain',
    '&.child': {
      left: '0.375rem',
    },
  },
  content: {
    width: '100%',
  },
  block: {
    display: 'block',
  },
  list: {
    padding: 0,
    listStyle: 'disc',
    '&.child': {
      padding: 0,
      listStyle: 'none',
    },
  },
  listItem: {
    color: palette.info.dark,
    fontSize: fontSizes.xs,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '0.5em',
      left: -10,
      display: 'block',
      width: 4,
      height: 4,
      borderRadius: '50%',
    },
    '&.child': {
      position: 'relative',
      color: palette.text.primary,
      fontSize: fontSizes.xs,
      lineHeight: 1.4,
    },
    '&.child:not(:last-child)': {
      marginBottom: 5,
    },
    '&.child::before': {
      width: 5,
      height: 5,
      background: 'linear-gradient(93.04deg, #24CE85 10.03%, #00A3E0 94.69%)',
    },
  },
  image: {
    display: 'block',
    maxWidth: '100%',
    margin: '0.675rem auto 0',
  },
  imageFirst: {
    marginBottom: '1.25rem',
  },
  listEmail: {
    color:' unset',
  },
}));
